import React from "react";
import {
  Box,
  Container,
  Typography,
  Card,
  Grid,
  Chip,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Stack,
  Breadcrumbs,
} from "@mui/material";
import HomeIcon from '@mui/icons-material/Home';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import Reel from "../tools/Reel";

const MotionCard = motion(Card);

const primary = "#0d1e4a";
const dark = "#c9a43b";
const light = "rgba(13,30,74,0.08)";

const tarifas = [
  {
    title: "Hasta el 31 de julio del 2026",
    highlight: false,
    data: [
      {
        label: "1 Participante",
        qt: "Q 3,200.00",
        usd: "$ 400.00",
      },
      {
        label: "Acompañante*",
        qt: "Q 1,600.00 c/u",
        usd: "$ 200.00 c/u",
      },
    ],
  },
  {
    title: "Desde el 1 de agosto 2026 hasta el día del evento",
    highlight: false,
    data: [
      {
        label: "1 Participante",
        qt: "Q 4,000.00",
        usd: "$ 500.00",
      },
      {
        label: "Acompañante*",
        qt: "Q 1,600.00 c/u",
        usd: "$ 200.00 c/u",
      },
    ],
  },
];

const includes = [
  "Conferencias y foros técnicos",
  "Refrigerios a.m. y p.m.",
  "Almuerzos",
  "Acceso al área de stands y expo comercial",
  "Certificado digital",
  "Grabación de conferencias",
  "Acceso a plataforma de Networking",
];

export default function Tarifas() {
  return (
    <Stack spacing={5} alignItems='center' style={{ background: "#f5f7f6", width: "100%" }} pt={3}>
      <Breadcrumbs aria-label="breadcrumb">
        <Link
          underline="hover"
          sx={{ display: 'flex', alignItems: 'center' }}
          color="inherit"
          to="/"
        >
          <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
          Inicio
        </Link>

        <Typography
          sx={{ color: 'text.primary', display: 'flex', alignItems: 'center' }}
        >
          <AttachMoneyIcon sx={{ mr: 0.5 }} fontSize="inherit" />
          Tarifas
        </Typography>

      </Breadcrumbs>
      <Box sx={{ py: 10 }}>
        <Container>

          {/* HEADER */}
          <Typography variant="h4" fontWeight="bold" sx={{ color: primary }}>
            TARIFAS COPLAFT 2026
          </Typography>

          <Box sx={{ width: 80, height: 4, background: primary, my: 2 }} />

          <Typography sx={{ mb: 4, color: "text.secondary" }}>
            20 y 21 de septiembre del 2026 · Salón Las Naciones, Hotel Barceló · Ciudad de Guatemala · *Aplica para eventos sociales · IVA Inluido
          </Typography>

          {/* TARJETAS */}
          <Grid container spacing={4}>
            {tarifas.map((item, i) => (
              <Grid item xs={12} key={i}>
                <MotionCard
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  whileHover={{ scale: 1.01 }}
                  transition={{ duration: 0.4 }}
                  sx={{
                    borderRadius: 4,
                    overflow: "hidden",
                    border: `2px solid ${primary}`,
                  }}
                >
                  {/* HEADER CARD */}
                  <Box
                    sx={{
                      background: light,
                      color: dark,
                      px: 3,
                      py: 2,
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      borderBottom: `2px solid ${primary}`,
                    }}
                  >
                    <Typography fontWeight="bold">
                      {item.title}
                    </Typography>
                  </Box>

                  {/* BODY */}
                  <Box sx={{ p: 3 }}>
                    {item.data.map((row, index) => (
                      <Box key={index}>
                        <Grid container spacing={2} alignItems="center">
                          <Grid item xs={12} md={4}>
                            <Typography fontWeight="bold">
                              {row.label}
                            </Typography>
                          </Grid>

                          <Grid item xs={6} md={4}>
                            <Typography>{row.qt}</Typography>
                          </Grid>

                          <Grid item xs={6} md={4}>
                            <Typography>{row.usd}</Typography>
                          </Grid>
                        </Grid>

                        {index !== item.data.length - 1 && (
                          <Divider sx={{ my: 2 }} />
                        )}
                      </Box>
                    ))}
                  </Box>
                </MotionCard>
              </Grid>
            ))}
          </Grid>

          {/* INCLUYE */}
          <Box mt={10}>
            <Typography
              variant="h5"
              fontWeight="bold"
              sx={{ color: primary, mb: 4 }}
            >
              LA INSCRIPCIÓN INCLUYE
            </Typography>

            <Grid container spacing={4}>
              {/* LISTA */}
              <Grid item xs={12} md={7}>
                <Card sx={{ borderRadius: 4, p: 3 }}>
                  <List>
                    {includes.map((item, i) => (
                      <ListItem key={i}>
                        <ListItemIcon>
                          <CheckCircleIcon sx={{ color: primary }} />
                        </ListItemIcon>
                        <ListItemText primary={item} />
                      </ListItem>
                    ))}
                  </List>
                </Card>
              </Grid>

              {/* INFO SEDE */}
              <Grid item xs={12} md={5}>
                <Card
                  sx={{
                    borderRadius: 4,
                    p: 3,
                    background: light,
                    border: `1px solid ${primary}`,
                  }}
                >
                  <Typography fontWeight="bold" mb={2} sx={{ color: dark }}>
                    Información del Evento
                  </Typography>

                  <Box display="flex" gap={1} flexWrap="wrap">
                    <Chip label="20-21 Sep 2026" sx={{ background: primary, color: '#fff', fontWeight: 'bold' }} />
                    <Chip label="Hotel Barceló" />
                    <Chip label="Ciudad de Guatemala" />
                    <Chip label="+250 participantes" />
                    <Chip label="Latinoamérica" />
                  </Box>
                </Card>
              </Grid>
            </Grid>
          </Box>
        </Container>
      </Box>
    </Stack>
  );
}
